import { api } from "@/lib/axios";
import { useMutation,   } from "@tanstack/react-query";
import { toast } from "sonner";
 
export const useExportBatchCsv = () => {
 
  return useMutation({
    mutationFn: async (batchId: string) => {
      const response = await api.get(`/api/user/export/batch-csv/${batchId}`, {
        responseType: 'blob',
      });
      return response.data;
    },
    onSuccess: (data, batchId) => {
       
      const blob = new Blob([data], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `batch_${batchId}_summary.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      toast.success("CSV downloaded successfully");
    },
    onError: () => {
      toast.error("Failed to download CSV");
    },
  });
}; 